<div class="leave-page">

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Leave Management
      </div>

      <h1>
        Leave Management
      </h1>

      <p>
        Manage employee leave requests and approvals.
      </p>

    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="addLeave()"
      *ngIf="canCreateLeave">

      <mat-icon>
        add
      </mat-icon>

      New Request

    </button>

  </div>


  @if (balances.length) {
    <section class="kpi-row">
      @for (b of balances; track b.id) {
        <div class="kpi">
          <span class="label">{{ b.policyName }} ({{ b.year }})</span>
          <strong>{{ b.remainingLeave }}</strong>
          <small>Total {{ b.totalLeave }} · Used {{ b.usedLeave }} · Pending {{ b.pendingLeave }} · Rejected {{ b.rejectedLeave }}</small>
        </div>
      }
    </section>
  }

  <mat-card class="leave-card">

    <div class="filters">

      <mat-form-field appearance="outline" class="search-field">

        <mat-label>
          Search leaves
        </mat-label>

        <input
          matInput
          [(ngModel)]="searchText"
          (ngModelChange)="filterLeaves()"
          placeholder="Employee, type or reason">

        <mat-icon matSuffix>
          search
        </mat-icon>

      </mat-form-field>

      <mat-form-field appearance="outline">

        <mat-label>
          Status
        </mat-label>

        <mat-select
          [(ngModel)]="selectedStatus"
          (selectionChange)="filterLeaves()">

          <mat-option *ngFor="let s of statuses" [value]="s">
            {{ s }}
          </mat-option>

        </mat-select>

      </mat-form-field>

      <button
        mat-button
        (click)="clearFilters()">

        Clear Filters

      </button>

    </div>

    <mat-divider></mat-divider>

    <div class="table-container">

      <table
        mat-table
        [dataSource]="filteredLeaves"
        class="leave-table">

        <ng-container matColumnDef="employee">
          <th mat-header-cell *matHeaderCellDef>
            Employee
          </th>
          <td mat-cell *matCellDef="let leave">
            {{ leave.employeeName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            Type
          </th>
          <td mat-cell *matCellDef="let leave">
            {{ leave.type }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dates">
          <th mat-header-cell *matHeaderCellDef>
            Dates
          </th>
          <td mat-cell *matCellDef="let leave">
            {{ leave.fromDate }} - {{ leave.toDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef>
            Reason
          </th>
          <td mat-cell *matCellDef="let leave">
            {{ leave.reason }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            Status
          </th>
          <td mat-cell *matCellDef="let leave">

            <span
              class="status-badge"
              [class.approved]="leave.status === 'Approved'"
              [class.rejected]="leave.status === 'Rejected'"
              [class.pending]="leave.status === 'Pending'">

              {{ leave.status }}

            </span>

          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            Actions
          </th>
          <td mat-cell *matCellDef="let leave">

            <button
              mat-icon-button
              color="primary"
              matTooltip="Forward to PM"
              (click)="forwardLeave(leave)"
              *ngIf="(leave.status === 'Pending' || leave.status === 'TeamLeadReview') && !leave.teamLeadForwardedAt && canForwardLeave">
              <mat-icon>forward</mat-icon>
            </button>

            <button
              mat-icon-button
              color="primary"
              matTooltip="Approve"
              (click)="approveLeave(leave)"
              *ngIf="(leave.status === 'ProjectManagerReview' || leave.status === 'HrReview' || leave.status === 'CeoReview' || (leave.status === 'Pending' && leave.teamLeadForwardedAt)) && canDecideLeave">
              <mat-icon>check</mat-icon>
            </button>

            <button
              mat-icon-button
              color="warn"
              matTooltip="Reject"
              (click)="rejectLeave(leave)"
              *ngIf="(leave.status === 'ProjectManagerReview' || leave.status === 'HrReview' || leave.status === 'CeoReview' || (leave.status === 'Pending' && leave.teamLeadForwardedAt)) && canDecideLeave">
              <mat-icon>close</mat-icon>
            </button>

            <button
              mat-icon-button
              matTooltip="Cancel"
              (click)="cancelLeave(leave)"
              *ngIf="leave.status !== 'Approved' && leave.status !== 'Rejected' && leave.status !== 'Cancelled' && canCreateLeave">
              <mat-icon>cancel</mat-icon>
            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <div class="no-data" *ngIf="filteredLeaves.length === 0">

        <mat-icon>
          event_busy
        </mat-icon>

        <h3>
          No Leave Requests Found
        </h3>

      </div>

    </div>

  </mat-card>

  @if (calendarDays.length) {
    <mat-card class="leave-card calendar-card">
      <h3>Leave calendar (this month)</h3>
      <div class="leave-cal">
        @for (d of calendarDays; track d.date) {
          <div class="cal-cell"
            [class.weekend]="d.isWeekend"
            [class.holiday]="d.isHoliday"
            [class.on-leave]="d.hasApprovedLeave"
            [title]="d.leaveEmployeeNames || d.holidayName || ''">
            {{ d.date | slice:8:10 }}
          </div>
        }
      </div>
    </mat-card>
  }

</div>
